import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import CustomButton from "../other/common/CustomButton";

const HeroFour = () => {
  return (
    <div className="bg-cover bg-no-repeat bg-center px-4 bg-inventors-hero-bg flex items-center justify-center">
      <div className="flex items-center justify-center flex-col py-[156px] max-xl:py-[130px] max-lg:py-28 max-md:py-20 max-sm:py-10">
        <BlueHeading
          lineClassOne="!bg-white"
          lineClassTwo="!bg-white"
          text="Memory"
          textClass="!text-white"
        />
        <h2 className="text-center text-white ff-jakarta font-bold text-6xl max-xl:text-[50px] max-lg:text-5xl max-md:text-4xl max-sm:text-3xl leading-[120%] max-w-[856px]">
          Water Holds Memory. Now It Holds Your Destiny
        </h2>
        <h3 className="text-white text-center ff-jakarta text-xl font-bold leading-[150%] pt-4">
          Deepak Sharma
        </h3>
        <p className="text-[#DDDDDD] text-center ff-jakarta text-base leading-[150%] font-normal pt-4">
          The Visionary Inventor Transforming Water Into a Life-Changing Force
        </p>
        <div className="flex items-center gap-4 mt-10 max-md:mt-6 flex-wrap max-md:justify-center ">
          <CustomButton
            myClass="!text-black !bg-white hover:!text-white hover:!bg-[#241DB6]"
            text="Discover the Inventions"
          />
          <CustomButton
            myClass="!text-white !bg-transparent  hover:!text-white hover:!bg-[#241DB6] !border-white"
            text="Watch How It Works"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroFour;
